import { useEffect, useState } from "react";

export default function AdminStats({ api, t }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, [api]);
  if (!s) return <div className="label-tech">{t("detail.loading")}</div>;

  const cards = [
    { k: "users_total", label: t("admin.stats.users") },
    { k: "listings_total", label: t("admin.stats.listings") },
    { k: "listings_hidden", label: t("admin.stats.hidden") },
    { k: "bookings_total", label: t("admin.stats.bookings") },
    { k: "bookings_pending", label: t("admin.stats.pending") },
    { k: "bookings_completed", label: t("admin.stats.completed") },
    { k: "bookings_rejected", label: t("admin.stats.rejected") },
    { k: "reports_open", label: t("admin.stats.reports") },
    { k: "ratings_total", label: t("admin.stats.ratings") },
    { k: "ratings_up", label: t("admin.stats.ratingsUp") },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-[var(--ink-200)] border border-[var(--ink-200)]">
      {cards.map((c) => (
        <div key={c.k} className="bg-[var(--bone)] p-5" data-testid={`stat-${c.k}`}>
          <div className="font-display text-3xl">{s[c.k]}</div>
          <div className="label-tech mt-2">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
